import React from "react";

function LegalSection() {
  return (
    <section className="legal-section" id="legal" aria-label="Informacion ligjor">
      <div className="container legal-grid">
        <div id="privacy-policy">
          <h2 id="privacy-heading" className="legal-heading">
            Privatësia
          </h2>
          <p className="legal-text">
            Përpunojmë të dhënat e kontaktit dhe projektit vetëm për t’iu përgjigjur pyetjeve,
            për të ofruar shërbime dhe për të përmbushur detyrime ligjore. Mund të kërkoni
            qasje, korrigjim ose fshirje të të dhënave personale ku zbatohet ligji. Zëvendësoni
            këtë përmbledhje me politikën tuaj specifike për juridiksionin kur të jeni gati.
          </p>
        </div>
        <div id="terms">
          <h2 id="terms-heading" className="legal-heading">
            Kushtet e shërbimit
          </h2>
          <p className="legal-text">
            Shërbimet ofrohen sipas një marrëveshjeje me shkrim që përcakton fushëveprimin,
            pronësinë intelektuale, garancitë dhe përgjegjësinë. Ky sajt është informues;
            kushtet kontraktuale konfirmohen për çdo angazhim. Zëvendësoni këtë tekst me
            kushte të miratuara nga juristi për entitetin tuaj.
          </p>
        </div>
      </div>
    </section>
  );
}

export default LegalSection;
